import { getEnv, getSite } from "@/src/utils/configUtils";
import tiktokPixel from "./analysis/TiktokPixel";
import {
    eCommerce,
    includeGaPath,
    insertAllPage,
    insertByparams,
} from "./analysis/gaLib/ga";
import { getLocalItem } from "@/lib/commonService";
import { IInsertGetPrescription } from "@/store/modules/prescription";
import { PAYMENTS } from "@/config/constConf";

const fbPixelLoadInit = (host: string) => {
    const PixelId0 = getEnv("PixelId0", host);
    const PixelId1 = getEnv("PixelId1", host);
    PixelId0 && fbPixelLoad(PixelId0);
    PixelId1 && fbPixelLoad(PixelId1);
};

const fbPixelLoad = (PixelId0: string) => {
    const head = document.getElementsByTagName("HEAD").item(0);
    const label = document.createElement("script");
    label.type = "text/javascript";
    label.innerHTML = `!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${PixelId0}');
  fbq('track', 'PageView');
`;

    head?.appendChild(label);
};

const tagManagerInit = (host: string) => {
    const GTM_ID = getEnv("GTM_ID", host);
    if (!GTM_ID) {
        return;
    }
    const head = document.getElementsByTagName("HEAD").item(0);
    const label = document.createElement("script");
    label.type = "text/javascript";
    label.innerHTML = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM_ID}');
`;
    head?.appendChild(label);
};

const newTikTokPixelLoad = (host: string) => {
    const codeMap: Record<string, any> = {
        default: {
            code: `window.snaptr=function(){}`,
            id: "",
        },
        uk: {
            code: `!function (w, d, t) {
            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};    
            ttq.load('C2H352NMU8QAJ3JEIHH0');
            ttq.page();
          }(window, document, 'ttq');

          (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
            {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
            a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
            r.src=n;var u=t.getElementsByTagName(s)[0];
            u.parentNode.insertBefore(r,u);})(window,document,
            'https://sc-static.net/scevent.min.js');
            
            snaptr('init', '82b9b83b-cf93-4c19-abe3-5cd73770d692', {
            'user_email': 'liusucai@gmail.com'
            });

            snaptr('track', 'PAGE_VIEW');`,
            id: "C2H352NMU8QAJ3JEIHH0",
        },
        //     us: {
        //         code: `!function (w, d, t) {
        //   w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};

        //   ttq.load('C3H6UMUPKKNB3CA8BUE0');
        //   ttq.page();
        // }(window, document, 'ttq');`,
        //         id: "C3H6UMUPKKNB3CA8BUE0",
        //     },
    };
    const site = getSite(host);
    const head = document.getElementsByTagName("HEAD").item(0);
    const { code, id } = codeMap[site] || codeMap.default;
    tiktokPixel.setId(id);
    let element = document.createElement("script");
    element.innerHTML = code;
    element.async = true;
    head?.appendChild(element);
};

const zendeskLoad = (host: string) => {
    const site = getSite(host);
    switch (site) {
        // 黑人站点
        case "fm":
            let script = document.createElement("script");
            script.id = "ze-snippet";
            script.async = true;
            script.src =
                "https://static.zdassets.com/ekr/snippet.js?key=b8a01e22-3998-4dd7-8111-cb9dc5fe26c3";
            document.body.appendChild(script);
            return;
    }
};

const obAdvLoad = (host: string) => {
    const site = getSite(host);
    switch (site) {
        case "us":
            const head = document.getElementsByTagName("HEAD").item(0);
            const label = document.createElement("script");
            label.type = "text/javascript";
            label.setAttribute("data-obct", "");
            label.innerHTML =
                "!function(_window, _document) {var OB_ADV_ID = '00602b31fc2be75295efb13d1f4d5910dc';if (_window.obApi) {var toArray = function (object) {return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];};_window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));return;}var api = _window.obApi = function () {api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);};api.version = '1.1';api.loaded = true;api.marketerId = OB_ADV_ID;api.queue = [];var tag = _document.createElement('script');tag.async = true;tag.src = '//amplify.outbrain.com/cp/obtp.js';tag.type = 'text/javascript';var script = _document.getElementsByTagName('script')[0];script.parentNode.insertBefore(tag, script);} (window, document);obApi('track', 'PAGE_VIEW');";
            head?.appendChild(label);
            return;
    }
};

const snaptrLoad = (host: string) => {
    const site = getSite(host);
    switch (site) {
        case "us":
            const customers_email_address = getLocalItem(
                "customers_email_address",
            );
            const head = document.getElementsByTagName("HEAD").item(0);
            const label = document.createElement("script");
            label.type = "text/javascript";
            label.innerHTML = `(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
                  {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
                  a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
                  r.src=n;var u=t.getElementsByTagName(s)[0];
                  u.parentNode.insertBefore(r,u);})(window,document,
                    'https://sc-static.net/scevent.min.js');
                    
                    snaptr('init', '01669e3b-a3b6-4682-83db-ad544f330edc', {
                    'user_email': '${customers_email_address}'
                    });
        
                    snaptr('track', 'PAGE_VIEW');`;

            head?.appendChild(label);
            return;
    }
};

export {
    fbPixelLoadInit,
    tagManagerInit,
    newTikTokPixelLoad,
    zendeskLoad,
    obAdvLoad,
    snaptrLoad,
};

// 谷歌分析
export const GoogleAnalytics = (
    custom_params?: any,
    GALoadedAsyncCb?: Function,
) => {
    insertAllPage().then((res) => {
        //使用异步调用
        GALoadedAsyncCb &&
            typeof GALoadedAsyncCb === "function" &&
            GALoadedAsyncCb();
        // console.log('custom_params', custom_params);
        if (includeGaPath(window.location.pathname) && custom_params) {
            insertByparams(custom_params);
        } else if (custom_params) {
            insertByparams(custom_params);
        } else {
            insertByparams();
        }
    });
};

// fb
export const facebookPixel = ({ trackPage, trackPageContent }: any) => {
    if (!window.fbq) {
        let retries = 0;
        const maxRetries = 20;

        const fbqCheckInterval = setInterval(() => {
            if (window.fbq) {
                clearInterval(fbqCheckInterval);
                window.fbq("track", trackPage, trackPageContent);
                console.log("facebookPixel 加载成功");
                console.log(trackPage, trackPageContent);
            } else if (retries >= maxRetries) {
                clearInterval(fbqCheckInterval);
                console.log("facebookPixel 加载失败");
            }
            retries++;
        }, 1000);
    } else {
        window.fbq("track", trackPage, trackPageContent);
        console.log(trackPage, trackPageContent);
    }
};

export const gaECommerce = (custom_params: any) => {
    eCommerce(custom_params);
};

export interface IClips {
    addons_id: number;
    basket_id: number;
    goods: string;
    image: string;
    is_selling: boolean;
    is_under_stock: boolean;
    mark: boolean;
    name: string;
    original_price: string;
    price: number;
    quantity: number;
    stock: number;
}
export interface IProducts {
    basket_id: number;
    frame_image?: string;
    products_frame?: string;
    frame_image_total?: number;
    frame_picture?: string;
    lens_rx_string?: any;
    master_categories_id?: any;
    original_price?: number;
    clips?: IClips[];
    color?: string;
    color_id?: number;
    have_clips?: number;
    color_number?: string;
    frame?: string;
    frame_origin_price?: number;
    frame_price?: number;
    glass_type?: string;
    goods?: string | "virtual" | "add-on" | "glasses" | "glass";
    has_rx?: boolean;
    image?: string;
    is_discounting?: boolean;
    is_fresh?: boolean;
    stock?: number;
    is_under_stock?: boolean;
    products_name_attribute?: string;
    lens_package?: any;
    lens_detail?: {
        name?: string;
        option_id?: string;
        option_value_id?: string;
        price?: string;
        value?: string;
    }[];
    lens_price?: number;
    lens_recommend?: {
        description?: {
            description?: string;
            price?: string;
        };
        lens?: any;
    };
    lens_rx?: Record<string, any>;
    price?: number;
    product_id?: number;
    product_id_hash?: string;
    product_type?: number;
    products_color_selling?: boolean;
    products_selling?: boolean;
    quantity?: number;
    lens_refractive?: number;
    lens_rx_edit?: Partial<IInsertGetPrescription>;
    total_price?: number;
    virtual_id?: number;
    addons_id?: number;
    id?: number;
    name?: string;
    products_have_sunmode?: number;
}

export interface IVirtual {
    virtual_id: number;
    total_price: number;
    quantity: number;
    price: number;
    original_price: number;
    name: string;
    is_selling: boolean;
    image: string;
    goods: "virtual";
    description: string;
    basket_share_tag: any[];
    basket_id: number;
}

export interface IAddOn {
    addons_id: number;
    basket_id: number;
    basket_share_tag: any[];
    goods: "add-on";
    image: string;
    is_selling: boolean;
    is_under_stock: boolean;
    mark: boolean;
    name: string;
    original_price: number;
    price: number;
    quantity: number;
    stock: number;
    total_price: number;
}

//虚拟商品接口
export interface VIRTUALS_GOOD {
    virtuals_description?: string;
    virtuals_description2?: string;
    virtuals_id?: number;
    virtuals_img?: string;
    virtuals_name?: string;
    virtuals_price?: string;
    virtuals_txt?: string;
}

export interface ADDONS_DATA {
    addons_id: number;
    addons_img: string;
    addons_name: string;
    addons_price: string;
    addons_price_org: string;
    addons_weight: number;
    addons_description: string;
    addons_qty: number;
    addons_category_id: number;
    id: number;
    img: string[];
    images?: string[]; // 可选的图片数组，用于轮播图
}

export type BASKET_GOODS = IAddOn | IVirtual | IProducts;
/**
 * 用于在处方选择时加购时获取埋点的参数
 */
export const getGAEventParamsForLens = (data: any) => {
    const { color_id, products_id, product_price, product } = data;
    const { search, pathname } = self.location;
    //区分h5 pc
    // const firstPath = isPc ? "pc" : "h5";
    const firstPath = "h5";
    return {
        id: products_id,
        item_id: products_id,
        name: product.products_model || "lens",
        item_name: product.products_model || "lens",
        list_name: `${firstPath}_${pathname}${search}`,
        brand: "",
        category: `${firstPath}_${pathname}${search}`,
        variant: color_id,
        list_position: 1,
        quantity: 1,
        price: (product_price && product_price.price) || 0,
    };
};
/**
 * 用于在下单时获取埋点的参数
 */
export const getGAStaticPramsForOrder = (
    list: IProducts[],
    paymentId: string,
) => {
    const event_label = getPayMethod(paymentId);
    let result = {
        items: [],
        event_label,
        content_type: event_label,
    };
    let items: any = [];
    if (!list || !list.length) return result;
    items =
        Array.isArray(list) &&
        list.map((item: IProducts) => {
            const { product_id, frame, name, addons_id, quantity, price } =
                item;
            return {
                id: product_id || addons_id,
                item_id: product_id || addons_id,
                quantity,
                price,
                name: frame || name || "",
                item_name: frame || name || "",
            };
        });
    result.items = items;
    return result;
};

const getPayMethod = (paymentId: string) => {
    let result = "";
    if (paymentId === PAYMENTS.PAYPAL || paymentId === PAYMENTS.BILLING) {
        result = "paypal";
    } else if (paymentId === PAYMENTS.CREDIT_CARD) {
        result = "ocean";
    }
    return result;
};

export const getIds = (ids: any, glasses: any) => {
    if (getSite(self.location.host) !== "uk") return ids;
    if (Array.isArray(ids)) {
        ids = ids.map((productId: any) => {
            const product = glasses.find(
                (glass: any) => glass.products_id === productId,
            );
            return product && product.color_id
                ? `${productId}-${product.color_id}`
                : productId;
        });
    } else if (ids) {
        const product = glasses.find(
            (glass: any) => glass[0].products_id === ids,
        );
        ids =
            product && product[0].color_id
                ? `${ids}-${product[0].color_id}`
                : ids;
    }
    return ids;
};

export function getContents(res: any) {
    const contents: any = [];
    const ttk_contents: any = [];
    res.orders_products.forEach((element: any) => {
        ttk_contents.push({
            content_id: `${element[0].products_id}`,
            price: parseFloat(element[0].products_price),
            content_type: "product",
            quantity: element[0].products_quantity,
        });
        contents.push({
            content_id: `${element[0].products_id}`,
            price: element[0].products_price,
            quantity: element[0].products_quantity,
        });
    });
    return { contents, ttk_contents };
}

export function getGApramasForChenckBtn(list: any[]) {
    if (!list || !list.length) return [];
    return list.map((item) => {
        const {
            product_id,
            color_id,
            quantity,
            price,
            addons_id,
            name,
            frame,
            goods,
        } = item;
        return {
            id: product_id || addons_id,
            item_id: product_id || addons_id,
            name: frame || name || "",
            item_name: frame || name || "",
            price,
            quantity,
        };
    });
}

export function mapIdsAndPriceOfProducts(products: any[], price: string) {
    return { ids: products.map((item) => item.product_id), price };
}
